module.exports = __webpack_public_path__ + "f563266c0f825b8626e0e8ebe4d4c969.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-italic-webfont.eot
// module id = 428
// module chunks = 0